<template>
    <div class="carousel-container">
        <div v-for="image in images" 
            :key="image.id"
            :class="['img-container', image.class]"
            @click="highlightImg(image.id)"
        >
            <img
            :src="image.src"
            :class="['image-' + image.class]"
            />
        </div>
    </div>
    <div class="text-container" ref="textContainer">
        <h3>ALWAYS WITH YOU</h3>
        <h1>Space that Travels</h1>
        <h2>A portable drive that goes wherever you do.</h2>
    </div>
 
  </template>
  
  <script>
  export default {
    data() {
      return {
        images: [
            { id: 0, src: 'figures/transport-carousel/transport-01.webp', class: 'small' }, 
            { id: 1, src: 'figures/transport-carousel/transport-02.webp', class: 'large' },
            { id: 2, src: 'figures/transport-carousel/transport-03.webp', class: 'small' },
            { id: 3, src: 'figures/transport-carousel/transport-04.webp', class: 'small' },
        ],
      };
    },
    mounted() {
    },
    methods: {
      highlightImg(id) {
        for (let image of this.images) {
          if(id === image.id) {
            image.class = 'large'
          } else {
            image.class = 'small'
          }
        }
        switch (id) {
          case 0:
              this.$refs.textContainer.style.left = "25%"
            break;
          case 1:
              this.$refs.textContainer.style.left = "45%"
            break;
          case 2:
              this.$refs.textContainer.style.left = "25%"
            break;
          case 3:
              this.$refs.textContainer.style.left = "40%"
            break;
        
          default:
            break;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  h1 {
    font-size: 52px;
  }

  h3 {
    font-family: 'ISO', monospace;
    font-size: 20px;
    letter-spacing: normal;
    font-weight: 600;
    color: #F9F9F9;
  }

  h2 {
    font-family: 'Untitled Serif', serif;
    font-size: 26px;
    letter-spacing: -1px;
    font-weight: 400;
    max-width: 48rem;
  }

  .carousel-container {
    display: flex;
    justify-content: center;
    max-width: 1250px;
    gap: 2rem;
    align-items: flex-start;
  }

  .img-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-basis: 0;
    flex-grow: 1;
    /* transition: all 0.15s cubic-bezier(0.19, 1, 0.22, 1); */
    transition: all 300ms cubic-bezier(0.87, 0.33, 0.26, 0.98);
    cursor: pointer;
  }

  .small {
    flex-grow: 1;
  }

  .large {
    flex-grow: 2;
    max-height: 100%;
    img {
      width: 100%;
    }
  }

  img {
    border-radius: 2vw;
    object-fit: cover;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 45%;
    top: min(40vw, 510px);
    /* transition: left 0.15s cubic-bezier(0.19, 1, 0.22, 1); */
    transition: left 300ms cubic-bezier(1, 0, 0.3, 0.93);
    transition-delay: 25ms;
  }



  
  </style>
  